import React, { useState, useMemo, useEffect } from "react";
import { Box, Container, Grid } from "@mui/material";
import { StatBox } from "./components/StatBox";
import { TabButton } from "./components/TabButton";
import { TaskList } from "./components/TaskList";
import { statBoxConfig, tabConfig } from "./constants";
import { useTaskDashboardContext } from "./context";
import dayjs from "dayjs";

export const TaskManagementDashBoardContainer = () => {
  const [activeFilter, setActiveFilter] = useState("active");
  const [counts, setCounts] = useState({
    overdue: 0,
    dueToday: 0,
    pending: 0,
    acknowledge: 0,
    active: 0,
    assigned: 0,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const { tasks, setTasks } = useTaskDashboardContext();
  useEffect(() => {
    let overdue = 0;
    let dueToday = 0;
    let pending = 0;
    let active = 0;
    let acknowledge = 0;
    let assigned = 0;
    tasks.forEach((item) => {
      if (item.category !== "acknowledge" && item.category !== "assigned") {
        if (dayjs().isAfter(item.dueDate, "day")) {
          overdue++;
        }
        if (dayjs().isSame(item.dueDate, "day")) {
          dueToday++;
        }
        if (item.category === "pending") {
          pending++;
        }
        if (item.category === "active") {
          active++;
        }
      } else {
        if (item.category === "acknowledge") {
          acknowledge++;
        } else if (item.category === "assigned") {
          assigned++;
        }
      }
    });
    setCounts({
      overdue,
      dueToday,
      pending,
      active,
      acknowledge,
      assigned,
    });
  }, [tasks]);
  const filteredTasks = useMemo(() => {
    let tasksToDisplay = [];
    if (activeFilter === "overdue") {
      tasksToDisplay = tasks.filter(
        (t) =>
          dayjs().isAfter(t.dueDate, "day") &&
          t.category != "acknowledge" &&
          t.category != "assigned"
      );
    } else if (activeFilter === "dueToday") {
      tasksToDisplay = tasks.filter(
        (t) =>
          dayjs().isSame(t.dueDate, "day") &&
          t.category != "acknowledge" &&
          t.category != "assigned"
      );
    } else if (activeFilter === "active") {
      tasksToDisplay = tasks.filter((t) => t.category === "active");
    } else if (activeFilter === "pending") {
      tasksToDisplay = tasks.filter((t) => t.category === "pending");
    } else if (activeFilter === "assigned") {
      tasksToDisplay = tasks.filter((t) => t.category === "assigned");
    } else if (activeFilter === "acknowledge") {
      tasksToDisplay = tasks.filter((t) => t.category === "acknowledge");
    }

    if (searchTerm) {
      return tasksToDisplay.filter(
        (task) =>
          task.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          task?.to?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          task?.from?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    return tasksToDisplay;
  }, [activeFilter, tasks, searchTerm]);

  return (
    <Box sx={{ backgroundColor: "#f8fafc", minHeight: "100vh", py: 4 }}>
      <Container maxWidth="lg">
        {/* --- STAT BOXES --- */}
        <Grid container spacing={{ xs: 2, md: 3 }} mb={4}>
          {statBoxConfig.map((stat) => (
            <Grid item xs={3} md={3} key={stat.id}>
              <StatBox
                {...stat}
                count={counts[stat.id]}
                onClick={() => setActiveFilter(stat.id)}
              />
            </Grid>
          ))}
        </Grid>

        {/* --- TAB BUTTONS --- */}
        <Grid container spacing={{ xs: 2, md: 3 }} mb={4}>
          {tabConfig.map((tab) => (
            <Grid item xs={6} md={3} key={tab.id}>
              <TabButton
                {...tab}
                count={counts[tab.id]}
                isActive={activeFilter === tab.id}
                onClick={() => setActiveFilter(tab.id)}
              />
            </Grid>
          ))}
        </Grid>

        {/* --- DYNAMIC CONTENT AREA --- */}
        <Box
          sx={{
            backgroundColor: "white",
            p: { xs: 2, sm: 3 },
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
          }}
        >
          <TaskList
            key={activeFilter}
            tasks={filteredTasks}
            filterType={activeFilter}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
        </Box>
      </Container>
    </Box>
  );
};
